import Errors from '@/views/errors'
import ErrorPage from '@/views/errors/error'
import Unauthorized from '@/views/errors/unauthorized'
import notFound from '@/views/errors/not-found'
import Developer from '@/views/developer'

import iframeErrors from '@/views/errors/iframe-erros'
import iframeErrorPage from '@/views/errors/iframe-erros/error'
import iframeUnauthorizedPage from '@/views/errors/iframe-erros/unauthorized'

import { storage } from '@/services/storage'

var routes = [
    {
        path: '/erros',
        name: 'errors',
        component: Errors,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Erros',
            protect: true
        },
        children: [
            {
                path: 'erro',
                name: 'errors.error',
                component: ErrorPage,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Erro',
                    protect: true
                }
            },
            {
                path: 'nao-autorizado',
                name: 'errors.not.unauthorized',
                component: Unauthorized,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Não Autorizado',
                    protect: true
                }
            },
            {
                path: 'notFound',
                name: 'errors.not.found',
                component: notFound,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Não Encontrado',
                    protect: true
                }
            }
        ]
    },
    {
        path: '/iframe',
        name: 'iframe.erro',
        component: iframeErrors,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Erros',
            protect: true
        },
        redirect: { name: 'iframe.errors.error' },
        children: [
            {
                path: 'erro',
                name: 'iframe.errors.error',
                component: iframeErrorPage,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Erro',
                    protect: true
                }
            },
            {
                path: 'unauthorized',
                name: 'iframe.errors.unauthorized',
                component: iframeUnauthorizedPage,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Unauthorized',
                    protect: true
                }
            }
        ]

    },
    {
        path: '/dev',
        name: 'dev',
        component: Developer,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Desenvolvimento',
            protect: true,
            rules: {
                groups: [
                    'admin',
                    'broker'
                ],
            }
        }

    }
]

export {
    routes
}